import { Component, OnInit } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Usuario } from '../models/usuario.model';
import { UsuarioService } from '../services/service.index';

import Swal from 'sweetalert2';

declare function init_plugins();

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  link = '';
  recuerdame = false;
  email: string;
  urlTree: UrlTree;
  constructor( public router: Router, public servicioUsuario: UsuarioService) { }

  ngOnInit() {
    init_plugins();

    // tomar parametros de URL
    this.urlTree = this.router.parseUrl(this.router.url);
    // tslint:disable-next-line: no-string-literal
    this.link = this.urlTree.queryParams['link'] || '';

    const usuario = new Usuario (
      '',
      'ingresos@nobissalud.com',
      '1234',
      '',
      'usuario'
    );
    this.servicioUsuario.login(usuario, false)
      .subscribe( resp => this.router.navigate(['/survey1?link=' + this.link]),
      err => {
              // tslint:disable-next-line: max-line-length
              // swalert('Atención', 'Los datos ingresados no son correctos!', 'warning');
              Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'Los datos ingresados no son correctos!'
              });
      });
  }

  ingresar( forma: NgForm) {
    if (!forma.valid) {
      return;
    }
    // const swalert: SweetAlert = _swal as any;
    const usuario = new Usuario (
      '',
      forma.value.email,
      forma.value.clave,
      '',
      'usuario'
    );

    this.servicioUsuario.login(usuario, forma.value.recuerdame)
      .subscribe( resp => this.router.navigate(['/survey1']),
      err => {
              // tslint:disable-next-line: max-line-length
              // swalert('Atención', 'Los datos ingresados no son correctos!', 'warning');
              Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: 'Los datos ingresados no son correctos!'
              });
      });
  }
}
